import Const from 'constants';

const StackItemInterface = {
    getId() {
        return this.uid;
    },
    getCorrelationBoost() {
        return Boolean(this.correlationBoost);
    },
    getKeyPlayerId() {
        return this.keyPlayerId;
    },
    getStackPlayers() {
        if (this.isTeamStackType()) {
            const stackPlayers = [];
            Object.values(this.stackPlayers).forEach((stackPlayer) => {
                if (stackPlayer.getIsKeyPlayerTeam()) {
                    stackPlayers.push(stackPlayer);
                }
            });
            return stackPlayers;
        }

        return Object.values(this.stackPlayers);
    },
    getFirstTeamStackPlayers() {
        const stackPlayers = [];
        Object.values(this.stackPlayers).forEach((stackPlayer) => {
            if (stackPlayer.getIsKeyPlayerTeam()) {
                stackPlayers.push(stackPlayer);
            }
        });

        return stackPlayers;
    },
    getSecondTeamStackPlayers() {
        const stackPlayers = [];
        if (this.isGameStackType()) {
            Object.values(this.stackPlayers).forEach((stackPlayer) => {
                if (!stackPlayer.getIsKeyPlayerTeam()) {
                    stackPlayers.push(stackPlayer);
                }
            });
        }

        return stackPlayers;
    },
    getStackPlayer(playerId) {
        return this.stackPlayers[playerId];
    },
    getFirstTeamAtLeastPlayers() {
        return Number(this.firstTeamAtLeastPlayers);
    },
    getFirstTeamAtMostPlayers() {
        return Number(this.firstTeamAtMostPlayers);
    },
    getSecondTeamAtLeastPlayers() {
        return Number(this.secondTeamAtLeastPlayers);
    },
    getSecondTeamAtMostPlayers() {
        return Number(this.secondTeamAtMostPlayers);
    },
    isTeamStackType() {
        return Const.CORRELATION_STACKING_TYPE_TEAM === this.stackType;
    },
    isGameStackType() {
        return Const.CORRELATION_STACKING_TYPE_GAME === this.stackType;
    },
    getMinExposure() {
        return this.exposure.min;
    },

    isSecondaryStackTypeNone() {
        return this.secondaryStackType === Const.CORRELATION_SECONDARY_STACK_TYPE_NONE;
    },
    isSecondaryStackTypeSingle() {
        return this.secondaryStackType === Const.CORRELATION_SECONDARY_STACK_TYPE_SINGLE;
    },
    isSecondaryStackTypeDouble() {
        return this.secondaryStackType === Const.CORRELATION_SECONDARY_STACK_TYPE_DOUBLE;
    },
    getSecondaryStackCombinations() {
        return {...this.secondaryStackCombinations};
    },
};

export default StackItemInterface;
